<template>
    <div class="msg-page">
        <van-nav-bar title="消息记录" left-text="返回" right-text="一键已读" @click-right="allRead()" @click-left="back" fixed left-arrow/>

        <div class="msg-list">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" error-text="请求失败，点击重新加载" @load="getMessage">
                <div
                    class="msg-card"
                    :class="{ 'is-unread': item.checked != 1 }"
                    v-for="(item,index) in list"
                    :key="item.id || index"
                    @click="readMsg(index)">
                    <div class="msg-icon-wrap" :class="msgIconTone(item)">
                        <van-icon :name="msgIcon(item)" />
                    </div>
                    <div class="msg-body">
                        <div class="msg-text">
                            <template v-if="user.userNameNeedTranslate == 1 && item.msg != null && item.msg.indexOf('$userName=') != -1">
                                <span>{{item.msg1}}</span>
                                <TranslationOpenDataText type='userName' :openid='item.msg2'></TranslationOpenDataText>
                                <span>{{item.msg3}}</span>
                            </template>
                            <template v-else-if="item.msg != null">{{item.msg}}</template>
                            <template v-else>{{msgType[item.type] || '消息通知'}}</template>
                        </div>
                        <div class="msg-time">
                            <van-icon name="clock-o" />
                            <span>{{ formatMsgTime(item.time) }}</span>
                        </div>
                    </div>
                    <van-icon name="arrow" class="msg-arrow" />
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                msgType: ["日报审核未通过", "有新任务", "任务有进展", "费用报销通知"],
                user: JSON.parse(localStorage.userInfo),

                total: 0,
                page: 1,
                size: 20,
                list: [],
                loading: false,
                finished: false,
                error: false,
                refreshing: false,

                show: false,
                title: "标题",
            };
        },
        methods: {
            allRead() {
                this.$axios.post("/information/checkAll", {})
                .then(res => {
                    if(res.code == "ok") {
                        this.getMessage();
                    }
                }).catch(err=> {this.$toast.clear();});
            },
            back() {
                history.back();
            },
            formatMsgTime(time) {
                if (!time) return '';
                return String(time).replace('T', ' ');
            },
            msgText(item) {
                if (!item) return '';
                if (item.msg != null && item.msg.indexOf('$userName=') != -1) {
                    return (item.msg1 || '') + (item.msg2 || '') + (item.msg3 || '');
                }
                if (item.msg != null) return item.msg;
                return this.msgType[item.type] || '';
            },
            // 按消息实际语义选图标，避免乱配
            msgIcon(item) {
                const text = this.msgText(item);
                // 驳回 / 未通过
                if (/驳回|未通过|不通过|拒绝|否决/.test(text) || item.type == 0 && /原因/.test(text)) {
                    return 'close';
                }
                // 通过 / 同意
                if (/通过|同意|已批准|审批通过/.test(text)) {
                    return 'checked';
                }
                // 撤销
                if (/撤销|撤回/.test(text)) {
                    return 'replay';
                }
                // 漏填 / 催办 / 提醒
                if (/漏填|催办|提醒|未填写|未填报/.test(text)) {
                    return 'bell';
                }
                // 异常
                if (/异常|预警|警告/.test(text)) {
                    return 'warning-o';
                }
                // 报销 / 费用
                if (item.type == 3 || /报销|费用/.test(text)) {
                    return 'balance-list-o';
                }
                // 任务
                if (item.type == 1 || item.type == 2 || /任务/.test(text)) {
                    return 'todo-list-o';
                }
                // 审核类
                if (/审核|审批|待审/.test(text)) {
                    return 'certificate';
                }
                // 日报
                if (/日报|工时/.test(text)) {
                    return 'notes-o';
                }
                if (item.type == 0) {
                    return 'close';
                }
                return 'bell';
            },
            msgIconTone(item) {
                const icon = this.msgIcon(item);
                if (icon === 'close' || icon === 'warning-o') return 'tone-danger';
                if (icon === 'checked') return 'tone-success';
                if (icon === 'todo-list-o' || icon === 'certificate') return 'tone-primary';
                if (icon === 'balance-list-o') return 'tone-warning';
                return 'tone-muted';
            },

            readMsg(index) {
                var item = this.list[index];
                if (item.type == 0) {
                    var date = item.content;
                    this.$axios.post("/information/check", {id:item.id
                    })
                    .then(res => {
                        if(res.code == "ok") {
                            this.getMessage();
                            this.$router.push('/edit?date='+date);
                        }
                    }).catch(err=> {this.$toast.clear();});
                } else {
                    this.$axios.post("/information/check", {id:item.id
                    })
                    .then(res => {
                        if(res.code == "ok") {
                            this.getMessage()
                            if (item.type == 1 || (item.msg != null && item.msg.indexOf('任务') > 0)) {
                                this.$router.push('/task');
                            } else if (item.type == 3) {
                                this.$router.push('/expense');
                            }
                        }
                    }).catch(err=> {this.$toast.clear();});
                }
            },

            getMessage() {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(this.total == this.list.length && this.list.length != 0) {
                    this.loading = false;
                    this.finished = true;
                    return false;
                }
                this.$axios.post("/information/list", {
                })
                .then(res => {
                    if(res.code == "ok") {
                        this.loading = false;
                        this.finished = true;
                        this.list = res.data;
                        for(let i in this.list){
                            if(this.list[i].msg != null && this.list[i].msg.indexOf('$userName=') != -1){
                                this.list[i].msg1 = this.list[i].msg.split('$')[0]
                                this.list[i].msg2 = this.list[i].msg.split('$')[1].split('=')[1]
                                this.list[i].msg3 = this.list[i].msg.split('$')[2]
                            }
                        }
                    } else {
                        this.$toast.fail('获取失败');
                    }
                }).catch(err=> {this.$toast.clear();});
            },

            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.page = 1;
                this.getMessage();
            },
        },
        mounted() {
        }
    };
</script>

<style lang="less" scoped>
    .msg-page {
        min-height: 100vh;
        background: #f5f6f8;
    }
    .msg-list {
        margin-top: 46px;
        padding: 10px 12px 20px;
    }
    .msg-card {
        display: flex;
        align-items: center;
        background: #fff;
        border-radius: 12px;
        padding: 14px 12px;
        margin-bottom: 10px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
    }
    .msg-card.is-unread {
        box-shadow: 0 2px 12px rgba(32, 160, 255, 0.1);
    }
    .msg-icon-wrap {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        margin-right: 12px;
        .van-icon {
            font-size: 20px;
        }
    }
    .tone-danger {
        background: #ffecec;
        color: #ee0a24;
    }
    .tone-success {
        background: #e8f8ef;
        color: #07c160;
    }
    .tone-primary {
        background: #e8f3ff;
        color: #1989fa;
    }
    .tone-warning {
        background: #fff7e8;
        color: #ff976a;
    }
    .tone-muted {
        background: #f2f3f5;
        color: #969799;
    }
    .msg-body {
        flex: 1;
        min-width: 0;
    }
    .msg-text {
        color: #323233;
        font-size: 14px;
        line-height: 1.45;
        word-break: break-all;
    }
    .msg-card.is-unread .msg-text {
        font-weight: 600;
    }
    .msg-time {
        margin-top: 6px;
        color: #969799;
        font-size: 12px;
        display: flex;
        align-items: center;
        .van-icon {
            font-size: 12px;
            margin-right: 4px;
        }
    }
    .msg-arrow {
        flex-shrink: 0;
        margin-left: 8px;
        color: #c8c9cc;
        font-size: 16px;
    }
</style>
<style lang="less">
    .van-nav-bar .van-icon , .van-nav-bar__text {
        color: #20a0ff;
    }
</style>
